import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import HeadingBlock from "./HeadingBlock";


export default /*#__PURE__*/_defineComponent({
  __name: 'Heading',
  props: {
    getBlock: null
  },
  setup(__props: any) {

const props = __props as {
	getBlock: () => HeadingBlock;
}



const block = computed(() => {
	return props.getBlock();
});

const blockText = computed({
	get: () => props.getBlock().text,
	set: (val) => {
		props.getBlock().text = val;
	}
});

function update(event: Event) {
	blockText.value = (event.target as HTMLElement).innerText;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(block).size == 1)
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          contenteditable: "true",
          class: "no-focus",
          onInput: update,
          onBlur: update
        }, _toDisplayString(_unref(blockText)), 33))
      : _createCommentVNode("", true),
    (_unref(block).size == 2)
      ? (_openBlock(), _createElementBlock("h2", {
          key: 1,
          contenteditable: "true",
          class: "no-focus",
          onInput: update,
          onBlur: update
        }, _toDisplayString(_unref(blockText)), 33))
      : _createCommentVNode("", true),
    (_unref(block).size == 3)
      ? (_openBlock(), _createElementBlock("h3", {
          key: 2,
          contenteditable: "true",
          class: "no-focus",
          onInput: update,
          onBlur: update
        }, _toDisplayString(_unref(blockText)), 33))
      : _createCommentVNode("", true),
    (_unref(block).size == 4)
      ? (_openBlock(), _createElementBlock("h4", {
          key: 3,
          contenteditable: "true",
          class: "no-focus",
          onInput: update,
          onBlur: update
        }, _toDisplayString(_unref(blockText)), 33))
      : _createCommentVNode("", true)
  ]))
}
}

})